import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import useStyles from './styles';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toast } from '@livable/saas-react-components';
import { TextField, Button } from '@mui/material';
import { BackdropLoader } from '@livable/saas-react-components';
import { AddNewAppfolioSchema } from 'src/utils/formValidation/Appfolio';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
export const AddNewForm = observer(_ref => {
  let callback = _ref.callback,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    handleStartValidate = _useState4[0],
    setHandleStartValidate = _useState4[1];
  const formik = useFormik({
    initialValues: {
      name: '',
      clientId: '',
      ownerEmail: '',
      companyName: '',
      clientSecret: '',
      ownerLastName: '',
      ownerFirstName: '',
      postalAddress: ''
    },
    validationSchema: AddNewAppfolioSchema,
    onSubmit: async () => {
      setIsLoading(true);
      setHandleStartValidate(true);
    }
  });
  const handleStartSubmitting = async _addressId => {
    try {
      const data = {
        name: formik.values.name,
        companyName: formik.values.companyName,
        clientId: formik.values.clientId,
        clientSecret: formik.values.clientSecret,
        addressId: _addressId
      };
      const resp = await store.credentials.postCredentialsAsync.run(data);
      if (resp && resp.isSuccessful) {
        await store.notifications.getAllNotificationsAsync.run();
        toast('success', {
          body: ['Successfully saved']
        });
        await callback();
        handleModalClose();
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleEndSubmitting = async () => {
    setIsLoading(false);
  };
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Client Id'),
    variant: "outlined",
    fullWidth: true,
    id: "clientId",
    name: "clientId",
    value: formik.values.clientId,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.clientId && Boolean(formik.errors.clientId),
    helperText: formik.touched.clientId && t(formik.errors.clientId, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Client Secret'),
    variant: "outlined",
    fullWidth: true,
    id: "clientSecret",
    name: "clientSecret",
    value: formik.values.clientSecret,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.clientSecret && Boolean(formik.errors.clientSecret),
    helperText: formik.touched.clientSecret && t(formik.errors.clientSecret, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Credential Name'),
    variant: "outlined",
    fullWidth: true,
    id: "name",
    name: "name",
    value: formik.values.name,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.name && Boolean(formik.errors.name),
    helperText: formik.touched.name && t(formik.errors.name, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Company Name'),
    variant: "outlined",
    fullWidth: true,
    id: "companyName",
    name: "companyName",
    value: formik.values.companyName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.companyName && Boolean(formik.errors.companyName),
    helperText: formik.touched.companyName && t(formik.errors.companyName, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    name: "postalAddress",
    validator: formik,
    disabled: isLoading || store.credentials.postCredentialsAsync.inProgress,
    error: formik.touched.postalAddress && Boolean(formik.errors.postalAddress),
    helperText: formik.touched.postalAddress && formik.errors.postalAddress ? t(formik.errors.postalAddress, {
      field: t('company_details.corporate_postal_mailing_address')
    }) : undefined,
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    _serviceEndSubmitting: handleEndSubmitting
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: formik.handleSubmit,
    disabled: !formik.isValid || !Object.keys(formik.touched).length || isLoading,
    variant: "priority",
    'custom-attribute': '22-appfolio-page-form'
  }, t('Save'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getGlAccountsAsync.inProgress || store.credentials.getCredentialsAsync.inProgress || store.credentials.postCredentialsAsync.inProgress || store.credentials.patchCredentialsAsync.inProgress || store.credentials.deleteCredentialAsync.inProgress || store.credentials.getCredentialsUsersAsync.inProgress || store.credentials.getCredentialsPropertiesAsync.inProgress || store.credentials.patchCredentialsPropertiesAsync.inProgress || store.address.addNewAddressAsync.inProgress
  }));
});